import type { TGroupShape, TOptionShape } from '@alfa-bank/site-select-v2/src/models/common';
import type { TSelectV2Desktop } from '@alfa-bank/site-select-v2/src/models/desktop';

import type { TOption, TOptionWithId } from '../models/common';

export const isOptionWithId = (option: unknown): option is TOptionWithId =>
    Boolean((option as TOptionWithId).id);

export const isOptionGroup = (item: TOptionShape | TOption | TGroupShape): item is TGroupShape =>
    Boolean((item as TGroupShape).options);

export const optionsToValue = (options: TSelectV2Desktop['selected']) => {
    return JSON.stringify(options);
};

export const getInputValue = (value: TOptionShape[], currentValueKey: 'key' | 'content') =>
    optionsToValue(value.map(item => item[currentValueKey] || item.key));

type TGetInitialValue = (
    options: Array<TOption | TGroupShape>,
    initialValueIndex?: number
) => Array<TOptionShape | TOption> | undefined;

export const getInitialValue: TGetInitialValue = (options, initialValueIndex) => {
    const tempArray: Array<TOptionShape | TOption> = [];

    if (!initialValueIndex && initialValueIndex !== 0) {
        return [];
    }
    options.forEach(item => {
        if (isOptionGroup(item)) {
            item.options.forEach(option => {
                tempArray.push(option);
            });
        } else {
            tempArray.push(item);
        }
    });

    return [tempArray[initialValueIndex] || tempArray[0]];
};
